module.exports = __webpack_public_path__ + "static/media/photograph.da8d89a4.svg";